// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__xARtG","inputWrap":"styles_inputWrap___vCRQ","input":"styles_input__3PUD8"};